<template>
  <div class="page" v-loading="loading">
    <el-form label-width="100px">
      <el-row>
        <el-col :span="8">
          <el-form-item label="品牌名称">
            <el-input v-model="searchData.Name"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item>
            <div class="flex">
              <el-button type="primary" @click="searchBtn">查询</el-button>
              <el-button @click="resetBtn">重置</el-button>
              <toolbar class="mgl10" :buttonList="buttonList_toolBar" @callFunction="callFunction"></toolbar>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div>
      <el-table border :data="tableList">
        <el-table-column type="selection" align="center" width="55"></el-table-column>
        <el-table-column label="品牌名称" prop="name" align="center"></el-table-column>
        <el-table-column label="品牌图标" align="center">
          <template slot-scope="scope">
            <img style="width:80px;height:80px;" v-if="scope.row.logoPic" :src="scope.row.logoPic" alt="">
            <el-tag size="mini" v-else>无</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="200">
          <template slot-scope="scope">
            <el-button size="mini" v-for="(item, index) in buttonList_table" :key="index" :type="item.buttonType"
              @click="callFunctionRow(item, index, scope.row)">{{ item.displayName }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" :total="total" :page-sizes="[10, 20, 30, 40, 50, 100]" class="pagination">
      </el-pagination>
    </div>
    <!-- 创建/修改 -->
    <el-dialog title="创建/修改" :visible.sync="dialogVisible1" width="30%">
      <el-form label-width="130px">
        <el-form-item label="品牌名称：">
          <el-input v-model="formData.name"></el-input>
        </el-form-item>
        <el-form-item label="品牌显示名称：">
          <el-input v-model="formData.displayName"></el-input>
        </el-form-item>
        <el-form-item label="品牌网址：">
          <el-input v-model="formData.webSiteAddress"></el-input>
        </el-form-item>
        <el-form-item label="品牌logo图：">
          <div class="img-box">
            <el-upload class="el_upload" action="#" :auto-upload="false" :show-file-list="false"
              :on-change="handleChange">
              <img v-if="formData.logoPic" :src="formData.logoPic" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <span class="mask" v-if="formData.logoPic">
                <!-- <span
                  @click.stop="handleBigPic(formData.logoPic)"
                >
                  <i class="el-icon-zoom-in"></i>
                </span> -->
                <span @click.stop="delPic()">
                  <i class="el-icon-delete"></i>
                </span>
              </span>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item label="是否可用：">
          <el-radio-group v-model="formData.isActive">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="submitBtn">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getButtonList } from "../../../promissionRouter";
import toolbar from "../../../components/Toolbar";
import {
  getQiniuToken,
  brandGetAll,
  BrandCreate,
  BrandDelete,
  BrandGet,
  BrandUpdate
} from '../../../api/api'
export default {
  components: {
    toolbar
  },
  data() {
    return {
      dialogVisible1: false,
      buttonList_toolBar: [],
      buttonList_table: [],
      tableList: [],
      total: 0,
      searchData: {
        Name: null,
        // Sorting: null,
        // SkipCount: 0,
        // MaxResultCount: 10
      },
      pageIndex: 1,
      pageSize: 10,
      formData: {
        name: '',
        displayName: '',
        webSiteAddress: '',
        logoPic: '',
        isActive: true
      },
      qiniuToken: '',
      loading: false
    }
  },
  created() {
    this.getTableData()
    this.getQiniuToken()
  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    var buttonList = getButtonList(this.$route.path, routers);
    const toolBarButtonList = buttonList.filter((item) => {
      return item.buttonShow === 10;
    });
    this.buttonList_toolBar = toolBarButtonList;

    const tableButtonList = buttonList.filter((item) => {
      return item.buttonShow === 20;
    });
    this.buttonList_table = tableButtonList;
  },
  methods: {
    createBtn() {
      this.dialogVisible1 = true
      this.formData = {
        name: '',
        displayName: '',
        webSiteAddress: '',
        logoPic: '',
        isActive: true
      }
    },
    //获取七牛token
    getQiniuToken() {
      var that = this;
      getQiniuToken().then((res) => {
        that.qiniuToken = res.data;
      })
        .catch(() => {
        });
    },
    searchBtn() {
      this.getTableData()
    },
    resetBtn() {
      this.searchData = {
        Name: null,
        // Sorting: null,
        // SkipCount: 0,
        // MaxResultCount: 10
      }
      this.pageIndex = 1
      this.pageSize = 10
      this.getTableData()
    },
    getTableData() {
      this.loading = true
      let data = {
        Name: this.searchData.Name,
        SkipCount: (this.pageIndex - 1) * this.pageSize,
        MaxResultCount: this.pageSize
      }
      brandGetAll(data).then(res => {
        // console.log(res)
        if (res.data.success) {
          this.tableList = res.data.result.items || []
          this.total = res.data.result.totalCount || 0
        } else {
          this.$message.error(res.data.error.message)
        }
        setTimeout(() => {
          this.loading = false
        }, 500)
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getTableData()
    },
    handleCurrentChange(val) {
      this.pageIndex = val
      this.getTableData()
    },
    callFunction(item) {
      this[item.buttonFunc](this, item);
    },
    callFunctionRow(item, index, row) {
      this[item.buttonFunc](item, index, row);
    },
    submitBtn() {
      if (this.formData.id) {
        BrandUpdate(this.formData).then(res => {
          if (res.data.success) {
            this.dialogVisible1 = false
            this.getTableData()
          } else {
            this.$message.error(res.data.error.message)
          }
        })
      } else {
        BrandCreate(this.formData).then(res => {
          if (res.data.success) {
            this.dialogVisible1 = false
            this.getTableData()
          } else {
            this.$message.error(res.data.error.message)
          }
        })
      }
    },
    editBtn(item, index, row) {
      BrandGet({ id: row.id }).then(res => {
        if (res.data.success) {
          this.dialogVisible1 = true
          this.formData = res.data.result
        } else {
          this.$message.error(res.data.error.message)
        }
      })
    },
    deleteBtn(item, index, row) {
      BrandDelete({ id: row.id }).then(res => {
        if (res.data.success) {
          this.$message.success('删除成功！')
          this.getTableData()
        } else {
          this.$message.error(res.data.error.message)
        }
      })
    },
    handleChange(file) {
      let that = this
      let fileSuf = file.name.split(".")[1];
      let qiniuData = {
        key: `KSAX/System/image/${new Date().getTime()}.${fileSuf}`,
        token: that.qiniuToken,
      };
      that.$utils.uploadImgToQiniu(file.raw, qiniuData).then((res) => {
        that.formData.logoPic = res
      })
        .catch((err) => {
          that.$message.error(err);
        });
    },
    delPic() {
      this.formData.logoPic = ''
    }
  }
}
</script>

<style scoped>
.brand-box {
  padding: 0 20px;
}

.form-box {
  background: #f5f5f5;
  padding: 20px 10px 0;
}

.form-bg {
  background: #f5f5f5;
  padding: 20px 10px 0;
}

.el-input {
  /* width: 300px; */
}

.img-box .el_upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 120px;
  height: 120px;
}

.img-box .el_upload:hover {
  border-color: #409eff;
}

.img-box .el_upload:hover .mask {
  opacity: 1;
}

.img-box .mask {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  cursor: default;
  text-align: center;
  line-height: 120px;
  color: #fff;
  opacity: 0;
  font-size: 20px;
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity 0.3s;
}

.img-box .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px !important;
  text-align: center;
}

.img-box .avatar {
  width: 120px;
  height: 120px;
}
</style>